import { createContext, Dispatch, SetStateAction } from 'react';

type TFilterableContext = {
  filter: Nullable<SectionsFilter>;
  setFilter: Dispatch<SetStateAction<Nullable<SectionsFilter>>>;
};

export const SectionsFilterableContext = createContext<TFilterableContext>(undefined!);
